import { render, staticRenderFns } from "./TaskSharedNavMenu.vue?vue&type=template&id=e85ee908&scoped=true&"
import script from "./TaskSharedNavMenu.vue?vue&type=script&lang=js&"
export * from "./TaskSharedNavMenu.vue?vue&type=script&lang=js&"
import style0 from "./TaskSharedNavMenu.vue?vue&type=style&index=0&id=e85ee908&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e85ee908",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VList } from 'vuetify/lib/components/VList';
installComponents(component, {VList})
